import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faArrowLeft,
    faArrowRight,
    faChevronLeft,
} from '@fortawesome/free-solid-svg-icons';
import SectionPagerStyle from './style';
import useQuoteSectionNav from 'src/hooks/useQuoteSectionNav';
import useIsMobile from 'src/hooks/useIsMobile';

const SectionPager: React.FC = () => {
    const { prev, next, buildPath } = useQuoteSectionNav();
    const isMobile = useIsMobile();

    if (!isMobile || (!prev && !next)) return null;

    if (!next && prev) {
        return (
            <SectionPagerStyle>
                <Link to={buildPath(prev.path)} className="btn btn-primary">
                    <FontAwesomeIcon icon={faArrowLeft} />
                    <span>{prev.tabLabel}</span>
                </Link>
            </SectionPagerStyle>
        );
    }

    return (
        <SectionPagerStyle>
            {prev && (
                <Link to={buildPath(prev.path)} className="btn btn-back">
                    <FontAwesomeIcon icon={faChevronLeft} />
                    <span>Back</span>
                </Link>
            )}
            {next && (
                <Link
                    to={buildPath(next.path)}
                    className="btn btn-primary btn-next"
                >
                    <span>{next.pagerLabel}</span>
                    <FontAwesomeIcon icon={faArrowRight} />
                </Link>
            )}
        </SectionPagerStyle>
    );
};

export default SectionPager;
